module.exports = __webpack_public_path__ + "img/information.f74aafb6.svg";